function optimizedLCPMonitor() {
  let lcpValue = 0;
  const lcpObserver = new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    const lastEntry = entries[entries.length - 1];
    lcpValue = lastEntry.startTime;
    if (lcpValue > 0) {
      document.body.classList.add('loaded');
      lcpObserver.disconnect();
      console.log('LCP:', Math.round(lcpValue) + 'ms');
    }
  });
  try {
    lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
  } catch (e) {
    setTimeout(() => {
      document.body.classList.add('loaded');
    }, 1000);
  }
  setTimeout(() => {
    document.body.classList.add('loaded');
    lcpObserver.disconnect();
  }, 3000);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', optimizedLCPMonitor);
} else {
  optimizedLCPMonitor();
}
